import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import { Dot } from 'lucide-react';

type VacanciesItemProps = {
    title: string;
    level: string;
    type: string;
};

export default function VacanciesItem({
    title,
    level,
    type,
}: VacanciesItemProps) {
    return (
        <div className="group border-primary hover:bg-lightyellow flex flex-col gap-3 border-b p-5 lg:flex-row lg:justify-between lg:gap-0">
            <H3
                variant="notItalic"
                className="line-clamp-2 w-full italic sm:w-5/6 lg:line-clamp-1 lg:w-2/3 lg:not-italic lg:group-hover:italic!"
            >
                {title}
            </H3>
            <div className="flex items-center justify-between lg:w-1/4 lg:pl-10">
                <div className="border-primary rounded-full border px-3 py-1">
                    <div className="flex items-center gap-2">
                        <Dot className="bg-primary h-2.5 w-2.5 rounded-full lg:h-3.5 lg:w-3.5" />
                        <Label>{level}</Label>
                    </div>
                </div>
                <Label className="ml-auto">{type}</Label>
            </div>
        </div>
    );
}
